<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15C6VXe/tc-custom/9781615953035.jpg?1731183709729" alt="This image is the cover for the book Book Deal, John Deal Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Book Deal, John Deal Series
      </h1>
      <p class="bookDescription body article font2">
        <p>Reluctant sleuth and Miami developer John Deal is the last of his kind - a builder who appreciates his craft. His friend Arch Dolan was the last of his kind, too, a Miami bookseller who sold books because he loved them. Now someone has killed him for it. And he's only the first body to fall. In quick succession the CEO of a huge bookstore chain and a local lawyer meet violent ends...and Deal starts finding connections. Still, it's not easy for Deal: his estranged wife Janice, is still emotionally and physically scarred from mishaps the last time Deal stepped into the path of the wrong people. But Janice was close to Arch and she's as eager to find the killer as her husband. Working together, they discover that Arch's sister, lately employed by a charismatic revivalist, has disappeared. With the clues pointing north, Deal and Janice set out on a journey to a distant and frigid climate, one that threatens to chill them out for good.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Les Standiford
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Poisoned Pen Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?36ee1ed7